export default __webpack_public_path__ + "253863475644afef57e4d30644ea0efc.webp";